/**
 * BrewSpot logo mark — a glass inside a map pin, one half of the name each.
 *
 * Replaces the raster logo-light.png / logo-dark.png pair: the PNGs were
 * authored at one size and visibly resampled in the header slot, and needing
 * two files meant the mark could drift between themes. The amber carries
 * enough contrast to sit on either palette unchanged.
 *
 * Drawn as silhouettes rather than strokes because a stroked tap collapsed
 * into an unreadable glyph once the mark shrank to the 32px header size.
 */
export default function BrandMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true" focusable="false">
      <path
        d="M16 1.75c-5.66 0-10.25 4.5-10.25 10.05 0 7.3 8.83 16.9 9.55 17.7a.95.95 0 0 0 1.4 0c.72-.8 9.55-10.4 9.55-17.7C26.25 6.25 21.66 1.75 16 1.75Z"
        fill="#F59E0B"
      />
      <path
        d="M12.4 6.6h7.2l-.83 9.1a1.8 1.8 0 0 1-1.79 1.64h-1.96a1.8 1.8 0 0 1-1.79-1.64L12.4 6.6Z"
        fill="#ffffff"
      />
      {/* Foam line: the one detail that turns a tapered box into a glass. */}
      <path d="M12.72 10.1h6.56l-.2 1.85h-6.16l-.2-1.85Z" fill="#F59E0B" />
    </svg>
  );
}
